// extracted by mini-css-extract-plugin
export default {"condition":"clbHd","digit":"obNqo","symbol":"OpvBt"};